"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateApplicationCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class CreateApplicationCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, appName) {
        super(api);
        this.app = {};
        this.withDescription = (description) => {
            this.app.description = description;
            return this;
        };
        this.withDeveloper = (developer) => {
            this.app.developer = developer;
            return this;
        };
        this.withDefinition = (def) => {
            this.app = { ...this.app, ...def };
            return this;
        };
        this.app.name = appName;
    }
    async exec() {
        return (await this.api.post('/applications', this.app)).data;
    }
}
exports.CreateApplicationCommand = CreateApplicationCommand;
//# sourceMappingURL=CreateApplicationCommand.js.map